import { z } from "zod";

export const labelSettingsSchema = z.object({
  defaultMode: z.enum(["web_direct", "local_driver"]).default("web_direct"),
  barcodeType: z.enum(["code128", "code39", "ean13"]).default("code128"),
  showFinancialCard: z.boolean().default(true),
  marginDots: z.coerce.number().int().min(0).max(100).default(14),
});

export type LabelSettings = z.infer<typeof labelSettingsSchema>;

export const DEFAULT_LABEL_SETTINGS: LabelSettings = {
  defaultMode: "web_direct",
  barcodeType: "code128",
  showFinancialCard: true,
  marginDots: 14,
};

export const maintenanceSettingsSchema = z.object({
  deductPartsStock: z.boolean().default(false),
});

export type MaintenanceSettings = z.infer<typeof maintenanceSettingsSchema>;

export const DEFAULT_MAINTENANCE_SETTINGS: MaintenanceSettings = {
  deductPartsStock: false,
};

export const depreciationSettingsSchema = z.object({
  method: z.enum(["none", "straight_line"]).default("straight_line"),
  residualRatePercent: z.coerce.number().min(0).max(100).default(5),
});

export type DepreciationSettings = z.infer<typeof depreciationSettingsSchema>;

export const DEFAULT_DEPRECIATION_SETTINGS: DepreciationSettings = {
  method: "straight_line",
  residualRatePercent: 5,
};

export const securitySettingsSchema = z.object({
  sourceWhitelistEnabled: z.boolean().default(false),
  allowedIps: z.array(z.string().trim().min(1).max(64)).max(200).default([]),
  turnstileEnabled: z.boolean().default(false),
  turnstileSiteKey: z.string().trim().max(200).optional().nullable(),
  turnstileSecret: z.string().max(500).optional().nullable(),
});

export type SecuritySettings = z.infer<typeof securitySettingsSchema>;

export const esignSettingsSchema = z.object({
  enabled: z.boolean().default(false),
  required: z.boolean().default(false),
  endpoint: z.string().trim().url("请输入有效 URL").max(2000).optional().nullable(),
  token: z.string().max(2000).optional().nullable(),
});

export type EsignSettings = z.infer<typeof esignSettingsSchema>;

export const stocktakeSettingsSchema = z.object({
  requireApproval: z.boolean().default(false),
});

export const disposalSettingsSchema = z.object({
  requireSeparateApprover: z.boolean().default(false),
});
